<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <!-- <el-button-group class="mb-3">
      <el-button @click="() => $refs.searchForm.toggleShow()">筛选</el-button>
    </el-button-group>

    <search-form ref="searchForm" :fields="search"/> -->
    <!-- 搜索头 -->
    <div
      class="filters"
      display:flex
    >
      <div class="selections">
        <el-button-group>
          <el-button
            type="primary"
            @click="dialogFormVisible=true"
            size="medium"
            round
          >
            批量操作
          </el-button>
          <el-button
            type="warning"
            size="medium"
            @click="clickBikesQrCodesDownload"
            round
          >
            导出车码
          </el-button>
          <el-button
            type="success"
            @click="dialogUploadVisible=true"
            size="medium"
            round
          >
            导入车辆
          </el-button>
          <el-button
            type="success"
            @click="dialogUploadBoxVisible=true"
            size="medium"
            round
          >
            导入中控
          </el-button>
        </el-button-group>
      </div>
      <search-form
        ref="searchForm"
        :fields="search"
      />
    </div>

    <!-- 表格 -->

    <el-table
      ref="multipleTable"
      :data="bikes"
      resource="bike"
      :row-key="row.id"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        :reserve-selection="true"
        :column-key="row.id"
        width="55"
        prop="id"
      />

      <!-- <el-table-column
        prop="id"
        label="ID"
        align="center"
        show-overflow-tooltip
        min-width="2%"
      />-->
      <el-table-column
        prop="bike_no"
        label="车辆编号"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="box_no"
        label="控制器编号"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />

      <el-table-column
        label="投放状态"
        align="center"
        show-overflow-tooltip
        mmin-width="90"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.put_status"
            type="success"
          >已投放</el-tag>
          <el-tag
            v-else
            type="danger"
          >未投放</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="在线状态"
        align="center"
        show-overflow-tooltip
        min-width="90"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.is_link"
            type="success"
          >在线</el-tag>
          <el-tag
            v-else
            type="danger"
          >离线</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="故障状态"
        align="center"
        show-overflow-tooltip
        min-width="90"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.is_trouble"
            type="danger"
          >有故障</el-tag>
          <el-tag
            v-else
            type="success"
          >无故障</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="剩余电量"
        align="center"
        show-overflow-tooltip
        min-width="100"
      >
        <template slot-scope="scope">
          <el-progress :percentage="scope.row.battery_power" />
        </template>
      </el-table-column>
      <el-table-column
        prop="put_area"
        label="投放区域"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        label="投放时间"
        align="center"
        show-overflow-tooltip
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag>{{ scope.row.put_time }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        min-width="120"
      >
        <template #default="{  row }">
          <input-edit
            :id="row.id"
            field="remark"
            :update="updateBikeRemark"
            v-model="row.remark"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="300"
      >
        <template #default="{ row,}">

          <row-to-edit />
          <el-button
            type="success"
            size="small"
            plain
            @click="rowClick(row)"
          >
            详情
          </el-button>
          <el-button
            type="warning"
            size="small"
            plain
            @click="qcodeClick(row)"
          >
            二维码
          </el-button>
          <row-destroy />
        </template>
      </el-table-column>
    </el-table>
    <!-- 表格end -->

    <!-- 弹窗批量设置表单 -->
    <el-dialog
      title="批量操作"
      :visible.sync="dialogFormVisible"
      width="30%"
    >
      <el-form :model="selectionsForm">
        <el-form-item label="投放区域">
          <el-select
            v-model="selectionsForm.put_area_id"
            clearable
            placeholder="选择区域"
          >
            <el-option
              v-for="i in put_areas"
              :key="i.id"
              :label="i.name"
              :value="i.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="投放状态"
          required
        >
          <el-radio
            v-model="selectionsForm.put_status"
            label="0"
          >未投放</el-radio>
          <el-radio
            v-model="selectionsForm.put_status"
            label="1"
          >已投放</el-radio>
        </el-form-item>
        <el-form-item label="投放时间">
          <el-date-picker
            v-model="selectionsForm.put_time"
            type="datetime"
            placeholder="选择日期时间"
          />
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitSelectionsForm"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!-- 批量设置表单end -->

    <!-- 弹框上传车辆excle -->
    <el-dialog
      title="导入车辆"
      :visible.sync="dialogUploadVisible"
      width="30%"
      style="text-align:center;"
    >
      <el-upload
        class="upload-demo"
        action="#"
        name="bikes"
        drag
        ref="fileupload"
        :show-file-list="false"
        :http-request="upLoadChange"
        :before-upload="beforeUpload"
      >
        <i class="el-icon-upload" />
        <div class="el-upload__text">将文件拖到此处，或<em>点击导入</em></div>
        <div
          class="el-upload__tip"
          slot="tip"
        >只能上传xls/xlsx文件，且不超过2MB</div>
      </el-upload>
      <el-button
        type="text"
        @click="downLoad"
      >点击下载模板</el-button>
    </el-dialog>
    <!-- 弹框上传excleend -->

    <!-- 弹框上传中控excle -->
    <el-dialog
      title="导入中控"
      :visible.sync="dialogUploadBoxVisible"
      width="30%"
      style="text-align:center;"
    >
      <el-upload
        class="upload-demo"
        action="#"
        name="boxs"
        drag
        ref="fileupload"
        :show-file-list="false"
        :http-request="upLoadBoxChange"
        :before-upload="beforeUpload"
      >
        <i class="el-icon-upload" />
        <div class="el-upload__text">将文件拖到此处，或<em>点击导入</em></div>
        <div
          class="el-upload__tip"
          slot="tip"
        >只能上传xls/xlsx文件，且不超过2MB</div>
      </el-upload>
      <el-button
        type="text"
        @click="downLoadBoxExample"
      >点击下载模板</el-button>
    </el-dialog>
    <!-- 弹框上传excleend -->

    <!-- 车辆二维码 -->
    <el-dialog
      title="车辆二维码"
      :visible.sync="dialogQrCodeVisible"
      width="30%"
      style="text-align:center;"
    >
      <img
        :src="QrCodeUrl"
        width="300px"
        height="300px"
        alt="二维码"
      >
    </el-dialog>
    <!-- 车辆二维码end -->

    <!-- 批量下载二维码 -->
    <el-dialog
      title="下载二维码"
      :visible.sync="dialogDownloadVisible"
      width="30%"
    >
      <div>
        <p class="downloadp">
          <span class="downloadform">下载范围：</span>
          <el-radio
            v-model="radio_download"
            @change="radioDownloadChange"
            label="1"
          >勾选项</el-radio>
          <el-radio
            v-model="radio_download"
            @change="radioDownloadChange"
            label="2"
          >本页</el-radio>
          <!-- <el-radio v-model="radio_download" @change="radioDownloadChange" label="3">全部</el-radio> -->
        </p>

        <p class="downloadp"><span class="downloadform">下载数量：</span> <span>已选择{{ download_number }}个</span></p>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogDownloadVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="bikesQrCodesDownload"
        >确 定</el-button>
      </span>
    </el-dialog>

    <!-- 批量下载二维码end -->

    <!-- 弹框详情信息 -->
    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <div class="detail_info">
        <div class="details">
          <div class="info-wrp">
            <div class="title">车辆信息</div>
            <div class="info-item">
              <span>车牌号:</span>
              <span>{{ row.bike_no }}</span>
            </div>
            <div class="info-item">
              <span>剩余电量:</span>

              <span>{{ row.battery_power }}%</span>
            </div>
            <div class="info-item">
              <span>故障状态:</span>
              <span>{{ row.status }}</span>
            </div>
            <div class="info-item">
              <span>车辆位置:</span>
              <span style="width:60%;">{{ row.position }}</span>
            </div>
            <div class="info-item">
              <span>总收益:</span>
              <span>{{ row.total_money }}</span>
            </div>
          </div>
          <div class="infodiv">
            <div class="title">控制器信息</div>
            <div class="info-item">
              <span>控制器编号:</span>
              <span>{{ row.box_no }}</span>
            </div>
          </div>
          <div class="infodiv">
            <div class="title">投放信息</div>
            <div class="info-item">
              <span>投放区域:</span>
              <span>{{ row.put_area }}</span>
            </div>
            <div class="info-item">
              <span>投放时间:</span>
              <span>{{ row.put_time }}</span>
            </div>
            <div class="info-item">
              <span>投放状态:</span>
              <span>{{ row.put_status }}</span>
            </div>
          </div>

        </div>
        <div class="ditu">
          <div
            class="amap-page-container"
            style="width: 100%!important;"
          >
            <el-amap
              ref="map"
              vid="amapDemo"
              :amap-manager="amapManager"
              :center="center"
              :zoom="zoom"
              :plugin="plugin"
              :events="events"
              class="amap-demoo"
            >
              <el-amap-marker
                :position="markerBikePosition.position"
                :events="markerBikePosition.events"
                :visible="markerBikePosition.visible"
                :draggable="markerBikePosition.draggable"
                :animation="markerBikePosition.animation"
                :icon="markerBikePosition.icon"
              />
              <el-amap-text
                :text="currentWindow.content"
                :offset="currentWindow.offset"
                :position="markerBikePosition.position"
              ></el-amap-text>

            </el-amap>
          </div>
        </div>

      </div>
      <div class="bigC">
        <div class="titleDiv">车辆控制:</div>
        <div class="detailDiv">
          <p>
            <el-button
              type="success"
              class="btnL"
              @click="controBike('bell')"
            >寻车</el-button>
            <el-button
              type="warning"
              class="btnL"
              @click="controBike('openLock')"
            >开锁</el-button>
            <el-button
              type="info"
              class="btnL"
              @click="controBike('closeLock')"
            >关锁</el-button>
            <el-button
              type="danger"
              class="btnL"
              @click="controBike('openBatteryLock')"
            >开电池锁</el-button>

            <el-button
              type="danger"
              class="btnL"
              @click="controBike('outLoseElectric')"
            >车辆失能</el-button>
            <el-button
              class="btnL"
              type="success"
              @click="controBike('outGetElectric')"
            >车辆获能</el-button>
          </p>
        </div>
      </div>
      <div class="bigC">
        <div class="titleDiv">状态更新:</div>
        <div class="detailDiv">
          <p>
            <el-button
              type="primary"
              class="btnL"
              @click="controBike('rebootBox')"
            >重启中控</el-button>
            <el-button
              type="primary"
              class="btnL"
              @click="controBike('nowBikeLocation')"
            >立即定位</el-button>
            <el-button
              class="btnL"
              type="primary"
              @click="controBike('nowBikeBatteryMSG')"
            >立即更新电量</el-button>

            <el-button
              class="btnL"
              type="primary"
              @click="controBike('repair')"
            >恢复正常</el-button>

          </p>
        </div>
      </div>

    </el-dialog>
    <!-- 弹框详情信息end -->

    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import Pagination from "@c/Pagination";
import SearchForm from "@c/SearchForm";
import {
  getBikes,
  bikesUpdate,
  importBikes,
  importBoxs,
  updateBikeRemark,
  bikeQrCode,
  getBikePosition
} from "@/api/bike";
import RowDestroy from "@c/LzTable/RowDestroy";
import RowToEdit from "@c/LzTable/RowToEdit";
import { mulBikesContro } from "@/api/bike";
import { getAreas } from "@/api/area";
import XLSX from "xlsx";
import axios from "@/plugins/axios";
import { mixinsAutoPageSize } from "@/libs/utils";
import InputEdit from "@c/quick-edit/InputEdit";
import VueAMap from "vue-amap";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../env";
export default {
  name: "Index",
  components: {
    RowToEdit,
    RowDestroy,
    Pagination,
    SearchForm,
    InputEdit
  },
  data() {
    let self = this;
    let amapManager = new VueAMap.AMapManager();
    return {
      currentWindow: {
        position: [0, 0],
        content: "最后定位时间",
        events: {},
        visible: false,
        offset: [0, -50]
      },
      innerVisible: false,
      clickBikeId: "",
      search: [
        {
          type: "super-input",
          field: "bike_or_box",
          label: "车牌号 / 控制器号"
        },
        {
          type: "el-select",
          field: "is_link",
          label: "是否在线",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              value: 1,
              label: "在线"
            },
            {
              value: 0,
              label: "离线"
            }
          ]
        },
        {
          type: "el-select",
          field: "is_trouble",
          label: "故障状态",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              value: 1,
              label: "有故障"
            },
            {
              value: 0,
              label: "无故障"
            }
          ]
        },
        {
          type: "el-select",
          field: "put_area_id",
          label: "投放区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          type: "el-select",
          field: "put_status",
          label: "是否投放",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              value: 1,
              label: "已投放"
            },
            {
              value: 0,
              label: "未投放"
            }
          ]
        },
        {
          type: "el-select",
          field: "battery_power",
          label: "选择电量",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              value: 10,
              label: "小于10%"
            },
            {
              value: 40,
              label: "小于40%"
            },
            {
              value: 60,
              label: "小于60%"
            },
            {
              value: 80,
              label: "小于80%"
            }
          ]
        },
        {
          field: "remark",
          label: "备注"
        },
        {
          field: "bike_no_bottom",
          label: "车牌号区间下限"
        },
        {
          field: "bike_no_top",
          label: "车牌号区间上限"
        }
      ],
      radio_download: "1",
      dialogVisible: false,
      dialogFormVisible: false,
      is_trouble: "",
      is_troubles: [
        {
          value: null,
          label: "全部"
        },
        {
          value: 1,
          label: "有故障"
        },
        {
          value: "0",
          label: "无故障"
        }
      ],
      is_link: "",
      is_links: [
        {
          value: null,
          label: "全部"
        },
        {
          value: 1,
          label: "在线"
        },
        {
          value: "0",
          label: "离线"
        }
      ],
      put_status: "",
      put_statuss: [
        {
          value: null,
          label: "全部"
        },
        {
          value: 1,
          label: "已投放"
        },
        {
          value: "0",
          label: "未投放"
        }
      ],
      put_area: "",
      put_areas: [
        {
          id: null,
          name: "无"
        }
      ],
      searchs: "",
      bikes: [],
      page: null,
      row: {
        bike_no: "",
        battery_power: Number,
        status: "",
        box_no: "",
        put_area: "",
        put_status: "",
        put_time: "",
        position: "",
        total_money: ""
      },
      selectionsForm: {
        put_area_id: "",
        put_status: "",
        put_time: ""
      },
      multipleSelection: [],
      multipleSelectionBikeNos: [],
      download_number: 0,
      dialogUploadVisible: false,
      dialogUploadBoxVisible: false,
      dialogQrCodeVisible: false,
      dialogDownloadVisible: false,
      QrCodeUrl: "",
      first_blood: true,
      zoom: 12,
      lng: 0,
      lat: 0,
      center: [121.59996, 31.197646],
      amapManager: amapManager,
      events: {
        init(o) {}
      },
      plugin: [
        {
          pName: "MapType",
          defaultType: 0,
          events: {
            init(o) {
              // console.log(o)
            }
          }
        },
        {
          pName: "Geolocation",
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              // console.log(o)
              o.getCurrentPosition((status, result) => {
                // 未配置https  定位失败 暂时手动配置
                self.lng = 113.73350255780726;
                self.lat = 34.78024666564106;
                // self.center = [self.lng, self.lat]
                self.loaded = true;
                if (result && result.position) {
                  self.lng = result.position.lng;
                  self.lat = result.position.lat;
                  // self.center = [self.lng, self.lat]
                  self.loaded = true;
                  self.$nextTick();
                }
              });
            }
          }
        },
        {
          pName: "Scale",
          // offset: { x: 20, y: 20 },
          position: "RB",
          events: {
            init(instance) {
              // console.log(instance)
            }
          }
        },
        {
          pName: "ToolBar",
          events: {
            init(instance) {
              // console.log(instance)
            }
          }
        }
      ],
      markerBikePosition: {
        position: [121.5273285, 31.21515044],
        events: {
          click: () => {}
        },
        visible: true,
        draggable: false,
        icon: "http://resource.bike.hanyiyun.com/common/using.admin.png"
      }
    };
  },
  inject: ["reload"],
  mixins: [mixinsAutoPageSize],
  methods: {
    updateBikeRemark,
    async rowClick(e) {
      // 详情
      this.dialogVisible = true;
      this.row.bike_no = e.bike_no;
      this.row.battery_power = e.battery_power;
      this.row.box_no = e.box_no;
      this.row.put_area = e.put_area;
      // console.log(e.put_status)
      this.row.put_status = e.put_status ? "已投放" : "未投放";
      this.row.put_time = e.put_time;
      this.row.status = e.is_trouble ? "有故障" : "无故障";
      this.row.position = e.position;
      this.row.total_money = e.total_money;
      this.clickBikeId = e.id;
      this.currentWindow.content = e.last_location_time;
      const [{ data: position }] = await Promise.all([
        getBikePosition({ bike_id: e.id })
      ]);
      this.row.position = position.position;
      this.center = e.last_location_app;
      this.zoom = 18;
      this.markerBikePosition.position = e.last_location_app;
    },
    handleSelectionChange(val) {
      // 多选改变时触发
      this.multipleSelection = val.map(i => i.id);
      this.multipleSelectionBikeNos = val.map(i => i.bike_no);
    },
    async submitSelectionsForm() {
      // 提交多选
      this.dialogFormVisible = false;
      const ids = this.multipleSelection;
      const bike_nos = this.multipleSelectionBikeNos;
      const updated = this.selectionsForm;

      const [{ data: res }] = await Promise.all([
        bikesUpdate({ ids: ids, bike_nos: bike_nos, updated: updated })
      ]);

      if (res) {
        this.$message({
          type: "success",
          message: "修改成功!"
        });
        this.reload();
      }
    },

    bikesQrCodesDownload() {
      // 批量下载二维码
      let radios = this.radio_download;
      // eslint-disable-next-line no-unused-vars
      var BikeNos = [];
      if (radios === "1") {
        // 勾选项
        BikeNos = this.multipleSelectionBikeNos;
      } else if (radios === "2") {
        BikeNos = this.bikes.map(i => i.bike_no);
      } else if (radios === "3") {
        // 与全选一致
      }
      axios
        .get(`bike/qrCodesDownload`, {
          params: {
            bike_nos: BikeNos
          },
          responseType: "arraybuffer"
        })
        .then(response => {
          // let a = response.resolve()
          // console.log(response)
          response
            .then(a => {
              // console.log(a)
              if (!a.data) {
                return;
              }
              let url = window.URL.createObjectURL(new Blob([a.data]));
              let link = document.createElement("a");
              link.style.display = "none";
              link.href = url;
              link.setAttribute("download", "qrcode.zip");

              document.body.appendChild(link);
              link.click();
              this.dialogDownloadVisible = false;
            })
            .catch(err => {
              this.$message.error("下载错误请确认是否勾选");
              this.dialogDownloadVisible = false;
            });
          // console.log(response)
        });
    },
    clickBikesQrCodesDownload() {
      // 点击按钮
      this.download_number = this.multipleSelectionBikeNos.length;
      this.dialogDownloadVisible = true;
    },
    radioDownloadChange() {
      // 单选选项改变
      let radios = this.radio_download;
      if (radios === "1") {
        this.download_number = this.multipleSelectionBikeNos.length;
      } else if (radios === "2") {
        // 本页数量
        this.download_number = this.page.to - this.page.from + 1;
        // console.log(this.download_number)
      } else if (radios === "3") {
        this.download_number = this.page.total;
      }
    },

    readExcel(file) {
      // 解析Excel
      let _this = this;
      return new Promise(function(resolve, reject) {
        const reader = new FileReader();
        reader.onload = e => {
          try {
            // 以二进制流方式读取得到整份excel表格对象
            var data = e.target.result;
            var workbook = XLSX.read(data, { type: "binary" });
          } catch (e) {
            reject(e.message);
          }
          resolve(true);
          // 暂时不删除excel验证
          // 表格的表格范围，可用于判断表头是否数量是否正确
          // var fromTo = ''
          // 遍历每张表读取
          // for (var sheet in workbook.Sheets) {
          //   let sheetInfos = workbook.Sheets[sheet]
          //   let locations = []// A1,B1,C1...
          //   if (workbook.Sheets.hasOwnProperty(sheet)) {
          //     fromTo = sheetInfos['!ref']// A1:B5
          //     locations = _this.getLocationsKeys(fromTo)
          //   }
          //   for (let i = 0; i < locations.length; i++) {
          //     console.log(locations)
          //     let value = sheetInfos[locations[i]].v
          //     let tvalue = '车牌号'
          //     if (value !== tvalue) {
          //       reject(locations[i] + '\'s parameter isn\'t ' + tvalue)
          //     }
          //   }
          //   resolve(true)
          // }
        };
        reader.readAsBinaryString(file);
      });
    },
    beforeUpload(file) {
      let _this = this;

      return new Promise(function(resolve, reject) {
        _this.readExcel(file).then(
          result => {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
              _this.$message.error("文件大小不能超过2MB!");
            }
            if (isLt2M && result) {
              resolve("校验成功!");
            } else {
              reject(false);
            }
          },
          error => {
            // console.log(error)
            _this.$message.error(error);
            reject(false);
          }
        );
      });
    },
    async controBike(type, command = "") {
      var arrId = [];
      arrId.push(this.clickBikeId);
      var params = { bikeIds: arrId, type: type };
      if (command !== "") {
        params = { bikeIds: arrId, type: type, command: command };
      }
      const [{ data: res }] = await Promise.all([mulBikesContro(params)]);

      if (res) {
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        // this.reload()
      }
    },

    async upLoadChange(content) {
      const [{ data: res }] = await Promise.all([importBikes(content.file)]);

      if (res) {
        this.$message({
          type: "success",
          message: "文件导入成功!"
        });
        this.reload();
      }
    },
    async upLoadBoxChange(content) {
      const [{ data: res }] = await Promise.all([importBoxs(content.file)]);

      if (res) {
        this.$message({
          type: "success",
          message: "文件导入成功!"
        });
        this.reload();
      }
    },
    downLoad() {
      // 下载模板
      axios
        .get(`bike/bikesDownload`, { responseType: "arraybuffer" })
        .then(response => {
          response.then(a => {
            if (!a.data) {
              return;
            }
            let url = window.URL.createObjectURL(new Blob([a.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", "example_bike_template.xlsx");

            document.body.appendChild(link);
            link.click();
          });
        });
    },
    downLoadBoxExample() {
      // 下载模板
      axios
        .get(`box/download`, { responseType: "arraybuffer" })
        .then(response => {
          response.then(a => {
            if (!a.data) {
              return;
            }
            let url = window.URL.createObjectURL(new Blob([a.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", "example_box_template.xlsx");

            document.body.appendChild(link);
            link.click();
          });
        });
    },
    getLocationsKeys(range) {
      // A1:B5输出 A1,B1...
      let startString = range.split(":")[0];
      let endString = range.split(":")[1];
      let start = startString.substring(0, startString.length - 1); // 字符'A'
      let end = startString.substring(0, endString.length - 1);
      let total = 0;
      for (let i = 0; i < end.length; i++) {
        total +=
          Math.pow(26, end.length - 1 - i) *
          (end.charCodeAt(i) - "A".charCodeAt(0) + 1);
      }
      let result = [];
      for (let index = 0; index < total; index++) {
        result.push(this.getCharByNum(index) + "1");
      }
      // let start = 0
      // let end = 0
      /* if (range.indexOf(':') >= 0) {
        start = range.split(':')[0].charAt(0)
        end = range.split(':')[1].charAt(0)
      } else {
        start = range
        end = range
      }
      let startCharCode = start.charCodeAt(0)
      let endCharCode = end.charCodeAt(0)
      for (let i = startCharCode; i <= endCharCode; i++) {
        result.push(String.fromCharCode(i) + '1')
      } */
      return result;
    },
    getCharByNum(index) {
      let a = parseInt(index / 26); // 整除
      let b = index % 26; // 余数
      let returnChar = String.fromCharCode(b + 65); // 最后一个字符
      while (a > 0) {
        b = a % 26;
        a = parseInt(a / 26);
        // 从后生成字符，向前推进
        returnChar = String.fromCharCode(b + 65 - 1) + returnChar;
      }
      return returnChar;
    },
    async qcodeClick(row) {
      const [{ data: QrCodeUrl }] = await Promise.all([
        bikeQrCode({ bike_no: row.bike_no })
      ]);
      this.dialogQrCodeVisible = true;

      this.QrCodeUrl = QrCodeUrl;
      // console.log(this.QrCodeUrl)
    }
  },
  async created() {
    const [{ data: areas }] = await Promise.all([getAreas({ all: 1 })]);
    this.put_areas.push.apply(this.put_areas, areas);
    this.search[3].options.push.apply(this.search[3].options, areas);
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[9].options.push.apply(
          this.search[9].options,
          merchant.data
        );
      }
    } 
  },
  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(53, newVal);
        const {
          data: { data, meta }
        } = await getBikes(newVal.query);

        this.bikes = data;
        this.page = meta;
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss" scoped>
.filters {
  // margin: 10px;
  .selectwidth {
    width: 100px;
    margin-right: 15px;
  }
  .searchs {
    width: 200px;
    margin-right: 15px;
  }
  .selections {
    display: inline-block;
    width: 32%;
    float: right;
    margin-right: 10px;
  }
}
.downloadp {
  padding: 0 10px 10px 20px;
  .downloadform {
    padding: 0 12px 0 0;
    font: bold;
  }
}
.detail_info {
  display: flex;
  justify-content: space-between;
  position: relative;
  .details {
    width: 50%;
    .infodiv {
      line-height: 1.15;
      // border-top: 1px solid #ccc;
      padding-bottom: 10px;
      .title {
        border-top: 1px solid #ccc;
        font-size: 16px;
        margin: 10px;
        padding-top: 10px;
      }
      .info-item {
        margin-left: 30px;
        margin-bottom: 10px;
        :first-child {
          display: inline-block;
          width: 85px;
          text-align: right;
          font-size: 14px;
          margin-right: 8px;
        }
      }
    }
    .info-wrp {
      // margin-top: -50px;
    }
    .info-wrp .title {
      font-size: 16px;
      margin: 10px;
      //margin: 20px 0 10px;
      padding-top: 10px;
      border-top: 1px solid #ccc;
    }
    .info-wrp .info-item {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      margin-bottom: 10px;
    }
    .info-wrp .info-item > span:first-child {
      display: inline-block;
      margin-right: 8px;
      width: 120px;
      text-align: right;
    }
    .info-wrp .pic-wrp > div:first-child {
      width: 120px;
      text-align: right;
    }
  }
  .bigC {
    display: flex;
    .titleDiv {
      width: 15%;
      margin-top: 15px;
    }
    .detailDiv {
      width: 80%;
      text-align: left;
      .btnL {
        margin-bottom: 10px;
        margin-left: 0px;
        margin-right: 10px;
      }
    }
  }
  .ditu {
    width: 45%;
    height: 100%;
    position: absolute;
    right: 10px;
    .amap-page-container {
      height: 100%;

      .amap-demoo {
        height: 97%;
        margin: auto 10px;
      }
    }
  }
}
</style>
